// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const LANDING_OPTIONS_CENTER_CONTENT_TITLE_PROPS = {
    dataTestId: 'landing-options-center-content-title',
    weight: VARIANTS.ParagraphWeightType.BOLD,
  },
  LANDING_OPTIONS_CENTER_CONTENT_DESCRIPTION_PROPS = {
    dataTestId: 'landing-options-center-content-description',
    size: VARIANTS.ParagraphSizesType.CAPTION_MEDIUM,
  };

export {
  LANDING_OPTIONS_CENTER_CONTENT_DESCRIPTION_PROPS,
  LANDING_OPTIONS_CENTER_CONTENT_TITLE_PROPS,
};
